export default function Education() {
  return (
    <section
      id="education"
      className="scroll-mt-24 py-20 px-6 bg-gray-50 text-gray-800"
      data-aos="fade-up"
    >
      <div className="max-w-4xl mx-auto text-left">
        <h2 className="text-3xl font-bold mb-8 transition-colors duration-300 hover:text-green-700 text-center">
          Education
        </h2>

        <div className="space-y-6">
          {/* PhD (Ongoing) */}
          <div className="p-5 bg-white rounded-xl shadow-md hover:shadow-xl transform hover:scale-[1.02] transition duration-300 border-l-4 border-green-600">
            <h3 className="text-xl font-semibold mb-1">
              Doctor of Philosophy (PhD) in Library & Information Science
            </h3>
            <p className="text-gray-600">
              University of Kerala — <span className="italic text-green-700">Ongoing</span>
            </p>
          </div>

          {/* MLISc */}
          <div className="p-5 bg-white rounded-xl shadow-md hover:shadow-xl transform hover:scale-[1.02] transition duration-300">
            <h3 className="text-xl font-semibold mb-1">
              Master of Library & Information Science (MLISc)
            </h3>
            <p className="text-gray-600">University of Kerala — 2021</p>
          </div>

          {/* BSc */}
          <div className="p-5 bg-white rounded-xl shadow-md hover:shadow-xl transform hover:scale-[1.02] transition duration-300">
            <h3 className="text-xl font-semibold mb-1">
              Bachelor of Science (BSc) in Physics
            </h3>
            <p className="text-gray-600">University of Kerala — 2018</p>
          </div>

          {/* Higher Secondary */}
          <div className="p-5 bg-white rounded-xl shadow-md hover:shadow-xl transform hover:scale-[1.02] transition duration-300">
            <h3 className="text-xl font-semibold mb-1">
              Higher Secondary Education (Science)
            </h3>
            <p className="text-gray-600">CBSE — 2014</p>
          </div>
        </div>
      </div>
    </section>
  );
}
